import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { NotificationsPageComponent } from './notifications-page.component';

@NgModule({
    declarations: [NotificationsPageComponent],
    imports: [CommonModule, FormsModule],
    exports: [NotificationsPageComponent]
})
export class NotificationsPageModule { }
